import React from "react";

import { IApplicationSetting } from "../../types/Request/AdminRequest";

interface Props {
  setting: IApplicationSetting;

  value: string;

  onChange: (value: string) => void;
}

const DynamicSettingInput: React.FC<Props> = ({ setting, value, onChange }) => {
  console.log(setting.displayName, setting.allowedValues);
  //--------------------------------------------------
  // Dropdown
  //--------------------------------------------------

  if (setting.allowedValues && setting.allowedValues.length > 0) {
    const options = setting.allowedValues
      .split(",")
      .map((x: string) => x.trim());

    return (
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-lg border border-slate-300 px-3 py-2 focus:ring-2 focus:ring-primary"
      >
        {options.map((option: string) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  }

  //--------------------------------------------------
  // Boolean
  //--------------------------------------------------

  if (setting.dataType === "Boolean") {
    const checked = value === "true";

    return (
      <button
        type="button"
        onClick={() => onChange(checked ? "false" : "true")}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          checked ? "bg-mainBrandColor" : "bg-mediumgray"
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            checked ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    );
  }

  //--------------------------------------------------
  // Integer / Decimal
  //--------------------------------------------------

  if (setting.dataType === "Integer" || setting.dataType === "Decimal") {
    return (
      <input
        type="number"
        value={value}
        min={setting.minValue}
        max={setting.maxValue}
        step={setting.dataType === "Decimal" ? "0.01" : "1"}
        onChange={(e) => onChange(e.target.value)}
        className="
w-full
h-11
rounded-lg
border
border-slate-300
bg-white
px-3
text-sm
transition
focus:border-[#2F5D2F]
focus:ring-2
focus:ring-green-100
outline-none
"
      />
    );
  }

  //--------------------------------------------------
  // Default Textbox
  //--------------------------------------------------

  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="
w-full
h-11
rounded-lg
border
border-slate-300
bg-white
px-3
text-sm
transition
focus:border-[#2F5D2F]
focus:ring-2
focus:ring-green-100
outline-none
"
    />
  );
};

export default DynamicSettingInput;
